// Mock data for My Insta Spaces Interior Design Website

export const companyInfo = {
  name: "My Insta Spaces",
  tagline: "A Personal and Convenient destination for all your interior designer needs",
  logo: "/logo_new.png",
  phone: "+91 81478 13339",
  email: "contact@myinstaspaces.com",
  address: "218/1, Opp HDFC Bank, Kammanahalli Main Road, Kalyan Nagar, Bangalore - 560043"
};

export const services = [
  {
    id: 1,
    title: "Turnkey Interiors",
    slug: "turnkey-interiors",
    description: "Our turnkey interior solutions cover everything from concept to completion. Our skilled team ensures high standards and timely delivery, creating spaces that reflect your unique style.",
    image: "https://images.pexels.com/photos/1571459/pexels-photo-1571459.jpeg?auto=compress&cs=tinysrgb&w=800",
    features: [
      "End-to-end solutions from design to installation",
      "Project management and coordination",
      "Quality materials and branded products",
      "45-day delivery guarantee",
      "10-year warranty on all work"
    ]
  },
  {
    id: 2,
    title: "Bedroom Interiors",
    slug: "bedroom-interiors",
    description: "Discover personalized bedroom designs that blend comfort and aesthetics. From contemporary to rustic, our experts create beautiful spaces for rest and relaxation.",
    image: "https://images.pexels.com/photos/1454806/pexels-photo-1454806.jpeg?auto=compress&cs=tinysrgb&w=800",
    features: [
      "Custom wardrobe designs",
      "Bed and headboard customization",
      "Lighting solutions for ambiance",
      "Space optimization",
      "Color consultation"
    ]
  },
  {
    id: 3,
    title: "Modular Kitchen",
    slug: "modular-kitchen",
    description: "Our modular approach optimizes space utilization. We design and manufacture customized solutions for efficient cooking and living environments.",
    image: "https://images.pexels.com/photos/2724749/pexels-photo-2724749.jpeg?auto=compress&cs=tinysrgb&w=800",
    features: [
      "L-shape, U-shape, Parallel & Straight layouts",
      "Premium hardware from Hettich & Hafele",
      "Soft-close mechanisms",
      "Water-resistant materials",
      "Appliance integration"
    ]
  },
  {
    id: 4,
    title: "Customized Kitchen",
    slug: "customized-kitchen",
    description: "Get a kitchen designed exactly to your specifications. We create bespoke kitchens that match your cooking style, storage needs, and aesthetic preferences.",
    image: "https://images.pexels.com/photos/2089696/pexels-photo-2089696.jpeg?auto=compress&cs=tinysrgb&w=800",
    features: [
      "Personalized layout planning",
      "Premium countertop options",
      "Custom cabinetry solutions",
      "Chimney and appliance selection",
      "Backsplash and tile design"
    ]
  }
];

export const trustIndicators = [
  {
    id: 1,
    icon: "BadgeIndianRupee",
    title: "Best Price Guarantee",
    description: "We offer cost-effective solutions that fit your budget."
  },
  {
    id: 2,
    icon: "Palette",
    title: "Personalized Design",
    description: "Our customized spaces are created to meet all of your requirements."
  },
  {
    id: 3,
    icon: "Clock",
    title: "On-Time Delivery",
    description: "Our on-time delivery benchmark is something we actively strive to uphold."
  },
  {
    id: 4,
    icon: "Headphones",
    title: "Best Customer Support",
    description: "Get unwavering assistance from our devoted care team as you complete your design journey."
  },
  {
    id: 5,
    icon: "Shield",
    title: "10 Years Warranty",
    description: "We maintain long-lasting client connections by providing ten-year warranties."
  }
];

export const designSteps = [
  {
    step: 1,
    title: "Connection",
    description: "Contact Us and Describe Your Need"
  },
  {
    step: 2,
    title: "Onboard Meeting",
    description: "Discuss project scope, budget, and process."
  },
  {
    step: 3,
    title: "Our Proposal",
    description: "Receive a detailed project proposal."
  },
  {
    step: 4,
    title: "Design",
    description: "Develop a concept aligned with your preferences."
  },
  {
    step: 5,
    title: "Presentation",
    description: "Share the overall vision for your new space."
  },
  {
    step: 6,
    title: "Execution",
    description: "Transform your dream into reality."
  }
];

export const comparisonData = {
  headers: ["Feature", "My Insta Spaces", "Typical Experience"],
  rows: [
    {
      feature: "PRICE",
      myInstaSpaces: ["No hidden costs", "Best value for money"],
      typical: ["45% hike between first quote & final cost"]
    },
    {
      feature: "CONVENIENCE",
      myInstaSpaces: ["One-stop shop for all interior needs"],
      typical: ["Approx 27 market trips to find everything"]
    },
    {
      feature: "DESIGN",
      myInstaSpaces: ["Personalised designs with 3D visuals"],
      typical: ["Cookie-cutter designs with 2D visuals"]
    },
    {
      feature: "TIMELINES",
      myInstaSpaces: ["45-day installation", "Regular updates with project tracking"],
      typical: ["Unreliable timelines", "No communication on updates/delays"]
    },
    {
      feature: "QUALITY",
      myInstaSpaces: ["Branded materials", "146 quality checks", "Superior technology for superior finishes"],
      typical: ["Inferior materials used to cut costs", "No quality checks", "Outsourced to small contractors"]
    },
    {
      feature: "WARRANTY",
      myInstaSpaces: ["Flat 10 year warranty", "India's first & only on-site service warranty"],
      typical: ["No warranty offered for products or services"]
    },
    {
      feature: "AFTER-SALES SUPPORT",
      myInstaSpaces: ["Dedicated team for prompt response & support"],
      typical: ["No after-sales support"]
    }
  ]
};

export const testimonials = [
  {
    id: 1,
    name: "Geeta",
    text: "The team listened to all our requirements and visions with utter patience. The final handover was exactly the way it was promised.",
    image: "https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=150"
  },
  {
    id: 2,
    name: "Shreya",
    text: "My home is a very sacred space for me. And I'm glad I choose My Insta Spaces to design it. The customer service from start to finish and the immaculate detailing is what truly impressed me. Don't think! Just go ahead and embrace the Insta Spaces experience.",
    image: "https://images.pexels.com/photos/1181686/pexels-photo-1181686.jpeg?auto=compress&cs=tinysrgb&w=150"
  },
  {
    id: 3,
    name: "Sharma",
    text: "As first-time homeowners, we wanted everything to be perfect! My Insta Spaces not only ensured that our home came together just like we wanted it to but also delivered it in the time frame they promised.",
    image: "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=150"
  },
  {
    id: 4,
    name: "Venkat",
    text: "The Best service for home interior concepts and able to understand the customer requirements and plan accordingly.",
    image: "https://images.pexels.com/photos/614810/pexels-photo-614810.jpeg?auto=compress&cs=tinysrgb&w=150"
  },
  {
    id: 5,
    name: "Suresh K",
    text: "He is one of the Best in the industry who is Very Creative, Passionate and Understands the customer requirements Best and suggests the Right Solutions. They design beautiful home interiors.",
    image: "https://images.pexels.com/photos/91227/pexels-photo-91227.jpeg?auto=compress&cs=tinysrgb&w=150"
  }
];

export const faqs = [
  {
    id: 1,
    question: "Why do I need an interior designer?",
    answer: "You can think of an interior designer as a film director. Their job is to monitor every minute detail from start to the final cut. From pre-production to the final edit, their perspective is responsible for shaping the final product. Similarly, interior designers are professionals who are able to gauge your needs and tastes to deliver your dream home. They assist you in getting custom-designed pieces that fit perfectly into your beautiful vision. From raw materials to finished products, they take care of everything!"
  },
  {
    id: 2,
    question: "Why is MyInstaSpaces perfect for your home interior design?",
    answer: "MyInstaSpaces offers end-to-end interior solutions with personalized designs, 3D visuals, 45-day installation guarantee, 146 quality checks, branded materials, and a flat 10-year warranty. We are your one-stop shop for all interior needs with dedicated customer support throughout your design journey."
  },
  {
    id: 3,
    question: "What services are included under home interior design?",
    answer: "Our home interior design services include turnkey interiors, bedroom design, modular kitchens, living room design, bathroom interiors, wardrobe solutions, false ceilings, electrical and lighting design, and complete home automation solutions."
  },
  {
    id: 4,
    question: "What is your approach to maximizing small spaces in residential design?",
    answer: "We use smart modular solutions, multi-functional furniture, strategic lighting, mirror placements, and vertical storage options to maximize every square foot. Our designers specialize in creating an illusion of space while maintaining functionality and aesthetics."
  },
  {
    id: 5,
    question: "How do you handle unforeseen challenges or delays during the project?",
    answer: "We maintain transparent communication throughout the project with regular updates via our project tracking system. In case of any unforeseen challenges, our dedicated project manager immediately informs you and presents solutions to minimize delays while maintaining quality standards."
  },
  {
    id: 6,
    question: "What are the trending interior design styles?",
    answer: "Current trending styles include Modern Minimalism, Scandinavian design, Industrial Chic, Japandi (Japanese-Scandinavian fusion), Biophilic design with nature elements, and Contemporary Indian fusion that blends traditional elements with modern aesthetics."
  }
];

export const heroImages = {
  main: "https://images.pexels.com/photos/1457842/pexels-photo-1457842.jpeg?auto=compress&cs=tinysrgb&w=1200",
  secondary: "https://images.pexels.com/photos/2089696/pexels-photo-2089696.jpeg?auto=compress&cs=tinysrgb&w=800"
};

export const designIdeas = [
  {
    id: 1,
    category: "Balcony",
    items: [
      { title: "Traditional Balcony", image: "https://images.pexels.com/photos/1643383/pexels-photo-1643383.jpeg?auto=compress&cs=tinysrgb&w=600", description: "Perfect complement to traditional railings, creating a larger virtual space." },
      { title: "Modern Balcony", image: "https://images.pexels.com/photos/2062426/pexels-photo-2062426.jpeg?auto=compress&cs=tinysrgb&w=600", description: "Can substitute your living room for lounging activities." },
      { title: "Contemporary Balcony", image: "https://images.pexels.com/photos/3935333/pexels-photo-3935333.jpeg?auto=compress&cs=tinysrgb&w=600", description: "Small space with huge potential, ideal for relaxation." }
    ]
  },
  {
    id: 2,
    category: "Living Room",
    items: [
      { title: "Traditional Living Room", image: "https://images.pexels.com/photos/1571460/pexels-photo-1571460.jpeg?auto=compress&cs=tinysrgb&w=600", description: "Warm and welcoming with comfort and calmness." },
      { title: "Modern Living Room", image: "https://images.pexels.com/photos/1571459/pexels-photo-1571459.jpeg?auto=compress&cs=tinysrgb&w=600", description: "Chic spaces ranging from cozy to contemporary layouts." },
      { title: "Minimalist Living Room", image: "https://images.pexels.com/photos/2227832/pexels-photo-2227832.jpeg?auto=compress&cs=tinysrgb&w=600", description: "Pared-back space exuding luxurious comfort." },
      { title: "Bohemian Living Room", image: "https://images.pexels.com/photos/3773575/pexels-photo-3773575.jpeg?auto=compress&cs=tinysrgb&w=600", description: "Raw, organic materials with accent pieces." }
    ]
  },
  {
    id: 3,
    category: "Bedroom",
    items: [
      { title: "Traditional Bedroom", image: "https://images.pexels.com/photos/1454806/pexels-photo-1454806.jpeg?auto=compress&cs=tinysrgb&w=600", description: "Authentic style packed with pattern and warmth." },
      { title: "Modern Bedroom", image: "https://images.pexels.com/photos/90317/pexels-photo-90317.jpeg?auto=compress&cs=tinysrgb&w=600", description: "Chicest sleep with gorgeous modern designs." },
      { title: "Minimalist Bedroom", image: "https://images.pexels.com/photos/3773583/pexels-photo-3773583.jpeg?auto=compress&cs=tinysrgb&w=600", description: "Focus on function with dramatic reduction of clutter." },
      { title: "Luxury Bedroom", image: "https://images.pexels.com/photos/3773580/pexels-photo-3773580.jpeg?auto=compress&cs=tinysrgb&w=600", description: "Decorative bedding, ceiling lights and elegant curtains." }
    ]
  },
  {
    id: 4,
    category: "Modular Kitchen",
    items: [
      { title: "L-Shape Kitchen", image: "https://images.pexels.com/photos/2724749/pexels-photo-2724749.jpeg?auto=compress&cs=tinysrgb&w=600", description: "Perfect for medium-sized spaces with wooden countertop." },
      { title: "U-Shape Kitchen", image: "https://images.pexels.com/photos/2089696/pexels-photo-2089696.jpeg?auto=compress&cs=tinysrgb&w=600", description: "Warm and welcoming with storage across the kitchen." },
      { title: "Parallel Kitchen", image: "https://images.pexels.com/photos/3016430/pexels-photo-3016430.jpeg?auto=compress&cs=tinysrgb&w=600", description: "Excellent in dark and light combination for small homes." },
      { title: "Straight Kitchen", image: "https://images.pexels.com/photos/1599791/pexels-photo-1599791.jpeg?auto=compress&cs=tinysrgb&w=600", description: "Most convenient with minimum space requirement." }
    ]
  },
  {
    id: 5,
    category: "Wardrobe",
    items: [
      { title: "Traditional Wardrobe", image: "https://images.pexels.com/photos/6312362/pexels-photo-6312362.jpeg?auto=compress&cs=tinysrgb&w=600", description: "Wooden and mirrored designs in various styles." },
      { title: "Modern Wardrobe", image: "https://images.pexels.com/photos/6312358/pexels-photo-6312358.jpeg?auto=compress&cs=tinysrgb&w=600", description: "Essential furniture piece to organize clothes and items." },
      { title: "Walk-in Closet", image: "https://images.pexels.com/photos/6312355/pexels-photo-6312355.jpeg?auto=compress&cs=tinysrgb&w=600", description: "Luxury walk-in makes room look roomier and brighter." }
    ]
  },
  {
    id: 6,
    category: "TV Units",
    items: [
      { title: "Traditional TV Unit", image: "https://images.pexels.com/photos/1571450/pexels-photo-1571450.jpeg?auto=compress&cs=tinysrgb&w=600", description: "Central attraction in living room decor." },
      { title: "Modern TV Unit", image: "https://images.pexels.com/photos/1571453/pexels-photo-1571453.jpeg?auto=compress&cs=tinysrgb&w=600", description: "Match your existing furniture with sleek design." },
      { title: "Contemporary TV Unit", image: "https://images.pexels.com/photos/3773576/pexels-photo-3773576.jpeg?auto=compress&cs=tinysrgb&w=600", description: "Storage space and shelves for displaying favorites." }
    ]
  }
];

export const packages = {
  interior: [
    {
      id: 1,
      name: "2 BHK",
      price: "3.9",
      unit: "Lakhs",
      tagline: "Make the best possible use of available space",
      features: ["Kitchen", "2 Wardrobes", "Crockery Units", "TV Unit", "Shoe Rack", "False Ceiling"]
    },
    {
      id: 2,
      name: "3 BHK",
      price: "4.9",
      unit: "Lakhs",
      tagline: "A room should smile at you and create fantasy",
      features: ["Kitchen", "3 Wardrobes", "Crockery Units", "TV Unit", "Shoe Rack", "Study Unit", "False Ceiling"],
      popular: true
    },
    {
      id: 3,
      name: "4 BHK",
      price: "5.9",
      unit: "Lakhs",
      tagline: "Balance function & amazing style with quality",
      features: ["Kitchen", "4 Wardrobes", "Crockery Units", "TV Unit", "Shoe Rack", "Study Unit", "False Ceiling"]
    }
  ],
  construction: [
    {
      id: 1,
      name: "Budget Package",
      price: "1,580",
      unit: "/sq.ft",
      features: ["2D Floor Plans", "3D Elevations", "Structural Drawings", "Standard Materials", "Basic Fittings"]
    },
    {
      id: 2,
      name: "Basic Package",
      price: "1,720",
      unit: "/sq.ft",
      features: ["2D & 3D Drawings", "Premium Steel", "UPVC Windows", "Better Fittings", "Virtual Tour"],
      popular: true
    },
    {
      id: 3,
      name: "Classic Package",
      price: "1,830",
      unit: "/sq.ft",
      features: ["Complete Drawings", "Premium Materials", "Quality Fittings", "Home Automation", "5 Year Warranty"]
    }
  ]
};

export const constructionServices = [
  { title: "Structural Design", icon: "Building", description: "Expert architectural and structural planning" },
  { title: "Construction", icon: "Hammer", description: "Quality construction with premium materials" },
  { title: "Interiors", icon: "Sofa", description: "Complete interior design and execution" },
  { title: "Utility", icon: "Wrench", description: "Electrical, plumbing, and utilities" },
  { title: "Authority Approvals", icon: "FileCheck", description: "Hassle-free government approvals" }
];

export const blogPosts = [
  {
    id: 1,
    title: "Top 10 Interior Design Trends for 2025",
    excerpt: "Discover the latest trends that are transforming homes across Bangalore. From sustainable materials to smart home integration.",
    image: "https://images.pexels.com/photos/1571460/pexels-photo-1571460.jpeg?auto=compress&cs=tinysrgb&w=600",
    category: "Trends",
    date: "Jan 10, 2025",
    readTime: "5 min read"
  },
  {
    id: 2,
    title: "How to Choose the Perfect Modular Kitchen",
    excerpt: "A comprehensive guide to selecting the right modular kitchen layout, materials, and accessories for your home.",
    image: "https://images.pexels.com/photos/2724749/pexels-photo-2724749.jpeg?auto=compress&cs=tinysrgb&w=600",
    category: "Kitchen",
    date: "Jan 8, 2025",
    readTime: "7 min read"
  },
  {
    id: 3,
    title: "Maximizing Small Bedroom Spaces",
    excerpt: "Smart storage solutions and design tricks to make your small bedroom feel spacious and luxurious.",
    image: "https://images.pexels.com/photos/1454806/pexels-photo-1454806.jpeg?auto=compress&cs=tinysrgb&w=600",
    category: "Bedroom",
    date: "Jan 5, 2025",
    readTime: "4 min read"
  },
  {
    id: 4,
    title: "Color Psychology in Interior Design",
    excerpt: "Understanding how colors affect mood and how to use them effectively in your home interiors.",
    image: "https://images.pexels.com/photos/3773575/pexels-photo-3773575.jpeg?auto=compress&cs=tinysrgb&w=600",
    category: "Design Tips",
    date: "Jan 3, 2025",
    readTime: "6 min read"
  }
];
